export default {
  banner: {
    title: "零信任身份认证解决方案",
    subtitle:
      "Authing 在零信任 IAM 的基础上结合云计算能力，构建零信任 IDaaS 方案，提供企业更高效、灵活的统一身份认证与身份治理功能。",
  },
  advantage: {
    title: "零信任 IAM 的优势与不足",
    subtitle:
      "身份识别与访问管理（IAM ）是零信任的基石，其核心技术包含身份认证、访问控制、身份治理和特权身份管理。IAM 决定了谁可以访问、如何访问、访问后可以执行哪些操作，能有效保障企业的信息安全，抵御风险。然而，传统 IAM 仍有许多不足之处：",
    item1: {
      title: "安全性欠佳",
      subtitle: "传统 IAM 在本地构建，难以保障混合云环境下的企业安全。",
    },
    item2: {
      title: "更新换代难",
      subtitle: "传统 IAM 需消耗巨大人力、时间来更新换代。",
    },
    item3: {
      title: "运维费用高",
      subtitle: "传统 IAM 需自行托管，企业自行雇佣或培养运维专家的成本较高。",
    },
    item4: {
      title: "伸缩性缺乏",
      subtitle:
        "当企业用户量上升，IAM 靠堆积服务器和设置负载均衡来优化，效率低。",
    },
  },
  idaas: {
    title: "Authing IDaaS，打造更高效的零信任身份治理",
    subtitle1:
      "Authing IDaaS 不仅覆盖了 IAM 的能力，基于云原生结构，还能解决传统 IAM 的安全和效率问题。",
    subtitle2:
      "企业无需自行维护服务器，就能享受安全、稳定、灵活的身份认证与管理服务。",
    item1: {
      title: "统一身份认证",
      subtitle:
        "Authing 支持多种认证方式，包括 OIDC、OAuth2.0、SAML、LDAP 等标准协议和钉钉、企业微信、飞书等第三方身份源，能帮助企业灵活快速地将多个系统的身份源进行统一。 ",
    },
    item2: {
      title: "单点登录 SSO",
      subtitle:
        "Authing 预集成了 2000+ 海内外应用，企业无需投入大量开发，即可快速接入，打通多个系统。此外，针对不支持标准认证协议的应用，Authing 也提供相应的单点登录方案。",
    },
    item3: {
      title: "自适应多因素认证 MFA",
      subtitle:
        "Authing 提供 OTP、短信、邮箱、人脸识别等多因素认证方式；并支持策略配置，通过判断位置（IP）、请求来源（设备）、行为分析等环境风险，实现动态、自适应的安全认证。",
    },
    item4: {
      title: "权限访问管理",
      subtitle:
        "Authing 支持 RBAC、ABAC 等权限模型，企业只需通过后台操作，即可创建对应的权限空间，设置数据、菜单、API 等资源的授权规则，实现细粒度的统一权限管理。",
    },
    item5: {
      title: "账号生命周期管理",
      subtitle:
        "通过 Authing 统一、自动化的账号管理方案，能避免人为失误导致的「越权账号被分配」和「离职账号未关停」情况，减少信息泄漏风险，保证企业生产流程的安全与合规。",
    },
    item6: {
      title: "自动化身份管理编排",
      subtitle:
        "Authing 提供了一套「自动化身份管理」编排工具和近 80 个身份管理自动化模版。企业能根据需求，以事件驱动，自定义身份管理业务中的数据与业务流程，提高管理效率。",
    },
  },
  security: {
    title: "选择 Authing，强化身份安全防御体系",
    detail: "查看详情案例",
    "content-title":
      "通过 Authing 打造零信任架构风控中台，满足银行的安全合规需求",
    "descript-list1":
      "完成银行内部 1000+ 应用的统一身份认证和单点登录，实现「一个账户登录所有应用」，减少重复、繁琐的管理操作，提高人效；",
    "descript-list2":
      "通过对部门、用户组、用户访问、用户权限的管理，有效的限制了跨权限访问的痛点，降低信息泄露的风险；",
    "descript-list3":
      "实现基于身份管理的策略配置、动态评估、监控告警、行为分析、行为溯源等功能，达到「事前管理防御」、「事中监测防护」、「事后审计追溯」的全链路能力。",
    extra: "——某大型股份制商业银行",
  },
  compliance: {
    title: "满足合规要求，居安全于首位",
    subtitle: "遵守不同国家与行业的合规性要求，积极参与安全标准的制定与推广",
    img1: "zero-trust-compliance1.png",
    img2: "zero-trust-compliance2.png",
    img3: "zero-trust-compliance3.png",
    img4: "zero-trust-compliance4.png",
    "descript-list1": "数据存储使用 AES-256 算法加密",
    "descript-list2": "数据通过 SSL/TLS 协议加密传输，2048 位 RSA 密钥 ",
    "descript-list3": "使用 KMS 管理密钥，密钥定期轮换，一次一密高安全保证",
  },
};
